import { omit } from 'utils/ObjectUtils';

import type {
  Guideline,
  GuidelineItem,
  GuidelineItemMedia,
  GuidelineItemMediaRequest,
  GuidelineItemRequest,
  GuidelineRequest,
} from './types';

// An uploaded media still carries the client-side upload state (`status`) and the URLs the API
// resolves on read (`path`, `thumbnailPath`); the API must not receive them back.
const mediaCleaner = (media: GuidelineItemMedia): GuidelineItemMedia | GuidelineItemMediaRequest =>
  (media?.status ? omit(media, 'path', 'status', 'thumbnailPath') : media);

const guidelineItemCleaner = (item: GuidelineItem): GuidelineItemRequest => ({
  ...item,
  exampleMedia: mediaCleaner(item.exampleMedia),
});

/** Strips the read-only media fields from a guideline before sending it to the API. */
export const guidelinesDataCleaner = (guideline: Guideline): GuidelineRequest => ({
  ...guideline,
  mandatory: guideline.mandatory?.map(guidelineItemCleaner),
  optional: guideline.optional?.map(guidelineItemCleaner),
});
